import { SHARED_DEALS } from '../sharedConfig';

export default {
  key: 'general10k',
  label: 'General Display Strategy - $10K+ Budget',
  strategySets: {
    default: {
      label: 'Standard (14 items)',
      lineItems: [
        { name: 'CPM_Broad_21+_X_DIS_Prospecting', segment: 'BROAD_21PLUS', budgetAllocation: 30 },
        { name: 'CPM_BT_Cannabis_Interest_WithSegments_DIS_Prospecting', segment: 'CANNABIS_INTEREST', budgetAllocation: 10 },
        { name: 'CPM_BT_Cannabis&THC_Interest_WithSegments_DIS_Prospecting', segment: 'CANNABIS_THC', budgetAllocation: 10 },
        { name: 'CPM_BT_CannabisDeliveryResearchers_KnownResearchers_WithSegments_DIS_Prospecting', segment: 'CANNABIS_DELIVERY', budgetAllocation: 10 },
        { name: 'CPM_BT_DispensaryVisitors_KnownVisitors_WithSegments_DIS_Prospecting', segment: 'DISPENSARY_VISITORS', budgetAllocation: 10 },
        { name: 'CPM_BT_DispensaryResearchers_KnownResearchers_WithSegments_DIS_Prospecting', segment: 'DISPENSARY_RESEARCH', budgetAllocation: 10 },
        { name: 'CPM_BT_CalmGummies_Interest_WithSegments_DIS_Prospecting', segment: 'CALM_GUMMIES', budgetAllocation: 2.5 },
        { name: 'CPM_BT_HolisticMedicine_Interest_WithSegments_DIS_Prospecting', segment: 'HOLISTIC_MEDICINE', budgetAllocation: 2.5 },
        { name: 'CPM_BT_Vape_Interest_WithSegments_DIS_Prospecting', segment: 'VAPE', budgetAllocation: 2.5 },
        { name: 'CPM_BT_SmokeShopVisitors_KnownVisitors_WithSegments_DIS_Prospecting', segment: 'SMOKE_SHOP', budgetAllocation: 2.5 },
        { name: 'CPM_BT_HealthWellness_Interest_WithSegments_DIS_Prospecting', segment: 'HEALTH_WELLNESS', budgetAllocation: 2.5 },
        { name: 'CPM_BT_Artists_MusicLovers_Interest_WithSegments_DIS_Prospecting', segment: 'ARTISTS_MUSIC', budgetAllocation: 2.5 },
        { name: 'CPM_BT_ConcertGoers_Interest_WithSegments_DIS_Prospecting', segment: 'CONCERT_GOERS', budgetAllocation: 2.5 },
        { name: 'CPM_BT_Beacon_PVBeacon_21+_DIS_Prospecting', segment: null, budgetAllocation: 2.5 },
      ],
    },
  },
  deals: SHARED_DEALS,
};
